import Scrollable from "@components/ui/Scrollable";
import {ComponentElem, ScrollableSetting} from "@components/interfaces";

export default class IndexLocationList extends Scrollable{
  constructor(elem: ComponentElem){

    let pcSetting: ScrollableSetting = 
    {
      itemWidth: 250,
      itemHeight: 180,
      gapX: 15,
      gapY: 15,
      numCols: 5,
      buttonMode: "press"
    }

    super(elem, pcSetting);
  }
}